import { render } from "./SewaTable.vue?vue&type=template&id=3928f127"
import script from "./SewaTable.vue?vue&type=script&lang=js"
export * from "./SewaTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__